export enum PriceListStatus {
    Active = 'active',
    Inactive = 'inactive',
}